import { SearchApi } from '@sportheroes/oly-engine-api';
import { olyEngineApi } from './Config/olyEngineApi';
const { SEARCH_API_URL = '' } = process.env;
export default new SearchApi(SEARCH_API_URL, {}, olyEngineApi);
